export function toggleHeader() {
    const header = document.querySelector('.header');

    window.scrollY > 130 ? header.classList.add('fixed') : header.classList.remove('fixed');
}
